// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__37xSM","content":"LayoutSettings_content__2LfIM"};